module.exports = __webpack_public_path__ + "img/irrigation-control-1.6342ff72.webp";